// ======================================================================
// File Name       : ServiceNoticeRegisterInfo
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Button, Col, Form } from 'react-bootstrap';
import { VALIDATE_TYPE } from '../../../constants/index';
import { SELECT_BOX_DATA } from '../../../constants/SelectBoxData';
import { RELEASE_TARGET } from '../../../constants/ServiceConstant';
import RenderField from '../../../utils/ReduxFormUtils';

class ServiceNoticeRegisterInfo extends React.Component {
  render() {
    const {
      invalid,
      publicStatus,
      userType,
      releasePeriod,
      releaseTarget,
      showSelectedGroupDialog,
      showSearchUserDialog,
      selectedTargetGroup,
      handleChangeUserType,
      radioChange,
    } = this.props;
    return (
      <div>
        <Form className="form-horizontal margin-top-10">
          <Col sm={12}>
            <Form.Group className="form-info">
              <Col as={Form.Label} sm={3}>
                タイトル<span className="required">&nbsp;(※)</span>
              </Col>
              <Col sm={7}>
                <RenderField
                  type="text"
                  name="noticeTitle"
                  label="タイトル"
                  validates={[VALIDATE_TYPE.REQUIRED]}
                />
              </Col>
            </Form.Group>
            <Form.Group className="form-info label-middle">
              <Col as={Form.Label} sm={3}>
                お知らせ内容<span className="required">&nbsp;(※)</span>
              </Col>
              <Col className='margin-bottom-10' sm={7}>
                <RenderField
                  type="textarea"
                  name="noticeContent"
                  label="お知らせ内容"
                  validates={[VALIDATE_TYPE.REQUIRED]}
                />
              </Col>
            </Form.Group>
            <Form.Group className="form-info">
              <Col as={Form.Label} sm={3}>
                公開期間
              </Col>
              <Col sm={7} className="padding-top-10">
                <RenderField
                  inline
                  className="padding-top-clear margin-right-10"
                  type="radio"
                  name="releasePeriod"
                  value={0}
                  normalizeRadio
                  label="無期限"
                  checkRadioChange
                  radioChange={radioChange}
                />
                <RenderField
                  inline
                  className="padding-top-clear"
                  type="radio"
                  name="releasePeriod"
                  value={1}
                  normalizeRadio
                  label="公開日指定"
                  checkRadioChange
                  radioChange={radioChange}
                />
              </Col>
            </Form.Group>
            {releasePeriod === 1 && (
              <Form.Group className="form-info">
                <Col
                  sm={{
                    span: 3,
                    offset: 3
                  }}>
                  <RenderField
                    type="datetime"
                    name="publicDateFrom"
                    validates={[VALIDATE_TYPE.DATE_TIME]}
                    normalizeDateTime
                  />
                </Col>
                <Col sm={1} className="text-center" as={Form.Label}>
                  ～
                </Col>
                <Col sm={3}>
                  <RenderField
                    type="datetime"
                    name="publicDateTo"
                    validates={[VALIDATE_TYPE.DATE_TIME]}
                    normalizeDateTime
                  />
                </Col>
                <Col sm={12}>
                  <RenderField
                    name="dateTimeMinMax"
                    type="dateTimeMinMax"
                    validates={[VALIDATE_TYPE.DATE_TIME_MIN_MAX]}
                    keyDateFrom={'publicDateFrom'}
                    keyDateTo={'publicDateTo'}
                  />
                </Col>
              </Form.Group>
            )}
            <Form.Group className="form-info">
              <Col as={Form.Label} sm={3}>
                公開範囲
              </Col>
              <Col sm={7}>
                <RenderField
                  type="selectbox"
                  name="userType"
                  label="公開範囲"
                  value={userType}
                  data={SELECT_BOX_DATA.USER_TYPE_NO_NULL}
                  normalizeRadio
                  handleChangeOption={handleChangeUserType}
                />
              </Col>
            </Form.Group>
            <Form.Group className="form-info">
              <Col
                sm={{
                  span: 3,
                  offset: 3
                }}
                className="padding-top-10 padding-bottom-10">
                <RenderField
                  inline
                  className="padding-top-clear margin-right-10"
                  type="radio"
                  name="releaseTarget"
                  value={RELEASE_TARGET.OVER_ALL}
                  normalizeRadio
                  label="全体"
                />
                <RenderField
                  inline
                  className="padding-top-clear"
                  type="radio"
                  name="releaseTarget"
                  value={RELEASE_TARGET.INDIVIDUAL}
                  normalizeRadio
                  label="個別"
                />
              </Col>
              {releaseTarget === RELEASE_TARGET.INDIVIDUAL && (
                <Col sm={4} className="text-center" style={{ marginLeft: '20px' }}>
                  <Button
                    variant="primary"
                    className="btn-96 margin-right-10"
                    onClick={showSelectedGroupDialog}
                  >
                    グループ選択
                  </Button>
                  <Button variant="primary" className="btn-96" onClick={showSearchUserDialog}>
                    ユーザー選択
                  </Button>
                </Col>
              )}
            </Form.Group>
          </Col>
        </Form>
      </div>
    );
  }
}

export default ServiceNoticeRegisterInfo;
